import axios from "axios";
import { API_URL } from "../constants";

export interface OnlineUser {
  id: string;
  name: string;
  position: string;
  avatarFileId: string | null;
  lastSeenAt: number | null;
  /** on a call right now — someone else is already talking to them */
  inCall?: boolean;
}

export async function sendHeartbeat() {
  await axios.post(`${API_URL}/presence/heartbeat`);
}

export async function fetchOnlineUsers(companyId: string): Promise<{
  self: OnlineUser | null;
  online: OnlineUser[];
  offline: OnlineUser[];
}> {
  const res = await axios.get(`${API_URL}/${companyId}/presence/online`);
  return res.data;
}
